import { DocumentLinkRegular, FluentIcon } from '@fluentui/react-icons';
import { ButtonLoading } from '@shared/components';
import useDetectionCountdown from '../../../hooks/useDetectionCountdown.hook';

type Props = {
  onCancel: () => void;
  onInsert: () => void;
  cancelLoading?: boolean;
  insertLoading?: boolean;
  insertDisabled?: boolean;
  count: number;
  nounSingular: string; // "reference" | "library item"
  nounPlural?: string; // defaults to nounSingular + "s"
  insertIcon?: FluentIcon;
  targetDate: string;
};

const PreviewActionsBar = ({
  onCancel,
  onInsert,
  cancelLoading,
  insertLoading,
  insertDisabled,
  count,
  nounSingular,
  nounPlural,
  insertIcon: InsertIcon = DocumentLinkRegular,
  targetDate,
}: Props) => {
  const label = `${count} ${count === 1 ? nounSingular : (nounPlural ?? `${nounSingular}s`)}`;
  const remainingSeconds = useDetectionCountdown(targetDate);
  const isExpired = remainingSeconds === 0;

  const handleInsert = () => {
    if (new Date(targetDate).getTime() - Date.now() < 1000) return;
    onInsert();
  };

  return (
    <div className="flex w-full justify-end space-x-2 py-3">
      <ButtonLoading
        loading={!!cancelLoading}
        disabled={!!insertLoading}
        appearance="secondary"
        size="medium"
        onClick={onCancel}
        className="w-fit"
      >
        Cancel
      </ButtonLoading>
      <ButtonLoading
        loading={!!insertLoading}
        disabled={!!insertDisabled || !!insertLoading || isExpired}
        appearance="primary"
        size="medium"
        icon={<InsertIcon />}
        onClick={handleInsert}
        className="w-fit"
      >
        Insert {label}
      </ButtonLoading>
    </div>
  );
};

export default PreviewActionsBar;
